import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import * as actions from '../actions/aircraft-category-collection';
import * as aircraftCategoriesServiceContracts from '../services/aircraft-categories/contracts';

import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class AircraftCategoryCollectionEffects {

  loadAircraftCategoryList$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<actions.LoadAction>(actions.LOAD),
    switchMap(() => {
      const request = new aircraftCategoriesServiceContracts.GetAircraftCategoryListRequest();

      return this.aircraftService.getAircraftCategoryList(request).pipe(
        map((serviceResponse) => {
          return new actions.LoadSuccessAction(serviceResponse.entities);
        })
      );
    })
  ));

  constructor(
    private actions$: Actions,
    @Inject(aircraftCategoriesServiceContracts.SERVICE_TOKEN)
    private aircraftService: aircraftCategoriesServiceContracts.IAircraftCategoriesService
  ) {}
}
